import { getImageSize } from '@/libs/utils/docxUtils'
import { AlignmentType, ImageRun, Paragraph, TextRun, PageBreak } from 'docx'

const Chapter4Sub3Page = async ({ barChart3Img }) => {
  const { width, height } = await getImageSize({ image: barChart3Img, width: 550 })

  return [
    new Paragraph({ children: [new PageBreak()] }),
    new Paragraph(''),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '依照人數統計之',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '「瀏覽郵件」、「點閱連結」、「開啟附件」與「輸入資料」',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '之人數統計直條圖表：',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph(''),
    new Paragraph(''),
    new Paragraph({
      alignment: AlignmentType.CENTER,
      // spacing: { before: pixelToDxa(30), after: pixelToDxa(30) },
      children: [
        new ImageRun({
          data: barChart3Img,
          transformation: {
            width,
            height,
          },
        }),
      ],
    }),
  ]
}

export default Chapter4Sub3Page
